import * as React from "react";
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    viewBox="0 0 42 42"
    {...props}
  >
    <g stroke="currentColor" strokeWidth={1.599} clipPath="url(#a)">
      <circle cx={21} cy={21} r={20.2} />
      <path
        strokeLinecap="round"
        d="M40.384 20.865h-6.61M8.66 20.865H2.05M20.86 1v6.61M20.86 33.253v6.61M7.065 7.063 9.87 9.867M31.367 31.365l2.804 2.804M7.065 34.667l2.805-2.804M31.367 10.365l2.804-2.804"
      />
      <path d="m26.823 8.491-9.26 9.931a.028.028 0 0 0 .007.043l6.859 3.389a.027.027 0 0 0 .04-.02L26.87 8.515c.005-.027-.028-.044-.047-.024Z" />
      <path d="m15.176 31.828 9.26-9.93a.027.027 0 0 0-.007-.044l-6.859-3.389a.028.028 0 0 0-.04.02l-2.401 13.32a.027.027 0 0 0 .047.023Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
